const initialState = {
  upload: {
    isLoading: false,
    error: [], // upload error messages are always array
  },
  save: {
    isLoading: false,
    error: '',
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
};

export default initialState;
